import React from 'react'
import { useSelector } from 'react-redux';
import {
    BrowserRouter as Router,
    Switch,
 
    Redirect
  } from "react-router-dom";

import { LoginScreen } from '../components/auth/LoginScreen';
import { DashboardRoutes } from './DashboardRoutes';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';

export const AppRouter = () => {
    const {uid} = useSelector(state => state.auth)

    return (
        <Router>
            <Switch>
                <PublicRoute exact path="/auth" component={LoginScreen} isAuthenticaded={!!uid}/>
                <PrivateRoute path="/" component={DashboardRoutes} isAuthenticaded={!!uid}/>

                <Redirect to="/" />
            </Switch>
        </Router>
    )
}
